// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_4RH","cls2":"ResearchInterestDirectorySearch-cls2_T48 ResearchInterestDirectorySearch-cls1_4RH"};